import { render, staticRenderFns } from "./LogsCard.vue?vue&type=template&id=4ab6d49e&scoped=true&lang=pug&"
import script from "./LogsCard.vue?vue&type=script&lang=ts&"
export * from "./LogsCard.vue?vue&type=script&lang=ts&"
import style0 from "./LogsCard.vue?vue&type=style&index=0&id=4ab6d49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab6d49e",
  null
  
)

export default component.exports